import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  section: {
    width: '100%',
  },
  createdAtWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  createdAtDate: {
    fontSize: '16px',
    color: theme.palette.textField.dark,
    lineHeight: theme.spacing(3),
  },
  createdAtTime: {
    fontSize: '14px',
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
  },
  root: {
    padding: '32px',
  },
}))
